import { useEffect } from 'react'
import { useQueryClient } from '@tanstack/react-query'
import { Navigate } from 'react-router-dom'
import { useAuthStore } from '../stores/authStore'
import {
  canAccessMailReview,
  isMailReviewDeploymentEnabled,
  purgeMailReviewCache,
} from '../features/mailReview/access'
import { useMailReviewAccess } from '../features/mailReview/useMailReviewAccess'

export function MailReviewCacheGuard() {
  const queryClient = useQueryClient()
  const canAccess = useMailReviewAccess()

  useEffect(() => {
    if (!canAccess) {
      purgeMailReviewCache(queryClient)
    }

    return () => purgeMailReviewCache(queryClient)
  }, [canAccess, queryClient])

  return null
}

export function MailReviewAccessRoute({ children }) {
  const user = useAuthStore((state) => state.user)
  const freshAuthVerified = useAuthStore(
    (state) => state.freshAuthVerified,
  )
  const deploymentEnabled = isMailReviewDeploymentEnabled()

  if (!deploymentEnabled) {
    return <Navigate to="/dashboard" replace />
  }

  if (freshAuthVerified !== true) {
    return <p className="text-sm text-gray-500">Verifying access...</p>
  }

  if (
    !canAccessMailReview({
      user,
      freshAuthVerified,
      deploymentEnabled,
    })
  ) {
    return <Navigate to="/dashboard" replace />
  }

  return children
}
